import React from "react";
import cx from "classnames";
import { Input } from "reactstrap";
import ModalWithDropDown from "../../components/ModalWithDropDown/ModalWithDropDown";
import DropDownN from "../DropDownN/DropDownN";
import { ModalConsumer } from "../../common/ModalContext";
import Button from "../../components/Button/Button";
import { LANGUAGES } from "../../constants/languages";
import { EMPLOYEES } from "../../constants/employees";
import styles from "./SpotForm.module.scss";

const ThirdStep = ({ state }) => {
  const {
    logo,
    titleSeo,
    setTitleSeo,
    descriptionSeo,
    setDescriptionSeo,
    validationError,
    setValidationError,
    onFileChange,
    foundationDate,
    setFoundationDate,
    languages,
    setLanguages,
    employees,
    setEmployees,
  } = state;
  const getButtonText = (selected, text, options) => {
    if (!selected) {
      return;
    }

    const selectedExistedInFilters = selected?.map((item) => {
      const items = options.find((option) => option.value === item);
      return items.label;
    });

    return selectedExistedInFilters.length
      ? `${selectedExistedInFilters[0]}${
          selectedExistedInFilters.length > 1
            ? ` + ${selectedExistedInFilters.length - 1}`
            : ""
        }`
      : text;
  };

  return (
    <div className={cx(styles.stepsContainer)}>
      <div className={cx(styles.formItem)}>
        <p className={styles.fieldLabel}>Foundation date </p>
        <Input
          name="foundationDate"
          placeholder="10/24/2015 (MM/DD/YYYY)"
          value={foundationDate}
          onChange={(event) => {
            setFoundationDate(event.target.value);
          }}
          className={cx(styles.input)}
        />
      </div>
      <div className={styles.formItem}>
        <div className={cx(styles.dropDownDesktop, styles.marginTopNone)}>
          <p className={styles.fieldLabel}>languages</p>
          <DropDownN
            name="languages"
            className={styles.autocomplete}
            isMultiple={true}
            onChange={setLanguages}
            selected={languages}
            onClear={() => setLanguages([])}
            options={LANGUAGES}
            buttonText={getButtonText(languages, "Languages", LANGUAGES)}
          />
        </div>
        <div className={cx(styles.dropDownMobile, styles.marginTopNone)}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p className={cx(styles.fieldLabel)}>Languages</p>
                <Button
                  onClick={() => {
                    toggleModal("languages");
                  }}
                  className={cx(
                    styles.filterButton,
                    languages.length ? styles.labelValue : styles.labelName
                  )}
                >
                  {getButtonText(languages, "languages", LANGUAGES)}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
      </div>
      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            modalId === "languages" && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                isMultiple={true}
                options={LANGUAGES}
                selected={languages}
                onChange={setLanguages}
                onClear={() => setLanguages([])}
              />
            )
          );
        }}
      </ModalConsumer>
      <div className={styles.formItem}>
        <div className={cx(styles.dropDownDesktop, styles.marginTopNone)}>
          <p className={styles.fieldLabel}>Number of employees</p>
          <DropDownN
            name="employees"
            className={styles.autocomplete}
            onChange={(value) => setEmployees([value])}
            selected={employees}
            onClear={() => setEmployees([])}
            options={EMPLOYEES}
            buttonText={getButtonText(employees, "Employees", EMPLOYEES)}
          />
        </div>
        <div className={cx(styles.dropDownMobile, styles.marginTopNone)}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p className={cx(styles.fieldLabel)}>Employees</p>
                <Button
                  onClick={() => {
                    toggleModal("employees");
                  }}
                  className={cx(
                    styles.filterButton,
                    {
                      [styles.dropDownError]:
                        validationError.includes("employees"),
                    },
                    employees.length ? styles.labelValue : styles.labelName
                  )}
                >
                  {getButtonText(employees, "employees", EMPLOYEES)}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
      </div>

      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            modalId === "employees" && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={EMPLOYEES}
                selected={employees}
                onChange={(value) => setEmployees([value])}
                onClear={() => setEmployees([])}
              />
            )
          );
        }}
      </ModalConsumer>
      <div className={cx(styles.stepsContainer, styles.spaceTop)}>
        <p className={styles.title}>SEO</p>
        <div className={cx(styles.formItem)}>
          <p className={styles.fieldLabel}>Title SEO</p>
          <Input
            name="titleSeo"
            placeholder="Title SEO"
            value={titleSeo}
            onChange={(event) => {
              setTitleSeo(event.target.value);
              setValidationError(
                validationError.filter((errorItem) => errorItem !== "titleSeo")
              );
            }}
            className={cx(styles.input, {
              [styles.inputError]: validationError.includes("titleSeo"),
            })}
          />
        </div>
        <div className={styles.textareaContainer}>
          <p className={styles.fieldLabel}>description SEO</p>
          <Input
            className={cx(styles.textarea, {
              [styles.inputError]: validationError.includes("descriptionSeo"),
            })}
            type="textarea"
            name="descriptionSeo"
            placeholder="Description SEO"
            onChange={(event) => {
              setDescriptionSeo(event.target.value);
              setValidationError(
                validationError.filter(
                  (errorItem) => errorItem !== "descriptionSeo"
                )
              );
            }}
            value={descriptionSeo}
          />
        </div>
        <div className={styles.inlineFormLogo}>
          <div className={styles.formItemLogo}>
            <p className={styles.fieldLabelLogo}>logo</p>
            <Input
              type="file"
              id="addLogo"
              className="d-none"
              multiple
              accept=".jpg, .png, .svg, .webp"
              onChange={(event) => {
                onFileChange(event.target.files[0] || null);
              }}
            />
            <label htmlFor="addLogo" className={styles.addLogoLabel}>
              {!logo && <span className={styles.circlePlus}> + </span>}
              {logo && <img src={logo} alt="logo" />}
            </label>
            <p
              className={cx(styles.fieldLabelTextLogo, {
                [styles.logoDescriptionsError]:
                  validationError.includes("logoSize"),
              })}
            >
              UP TO 100KB PNG/JPG/SVG/WEBP
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdStep;
